
import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { newTherapyTemplateAction, therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
    DELETE_SINGLE_MDS_ASSESSMENT_BY_REQUEST,
    DELETE_SINGLE_MDS_ASSESSMENT_BY_SUCCESS,
    DELETE_SINGLE_MDS_ASSESSMENT_BY_FAILURE,
    DELETE_SINGLE_MDS_ASSESSMENT_BY_RESET,
    DELETE_SINGLE_MDS_ASSESSMENT_BY_LOADING,
} = therapyPlanningAction;

function* deleteSingleMdsAssessment(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: DELETE_SINGLE_MDS_ASSESSMENT_BY_LOADING });
    const response = yield call(therapyPlanningService.deleteSingleMds, payload.payload);
    if (response?.status === 200) {
      yield put({
        type: DELETE_SINGLE_MDS_ASSESSMENT_BY_SUCCESS,
        payload: response?.data,
      });
    } else throw response;
  } catch (error) {
    yield put({ type: DELETE_SINGLE_MDS_ASSESSMENT_BY_FAILURE, payload: error });
  }
}

function* deleteSingleMdsAssessmentSaga() {
  yield takeEvery(DELETE_SINGLE_MDS_ASSESSMENT_BY_REQUEST, deleteSingleMdsAssessment);
}

export default deleteSingleMdsAssessmentSaga;
